// Scroll to anchor

$(function () {
  $('a.scroll-to').click(function (e) {
    e.preventDefault();

    const $dest = $($(this).attr('href'));
    const scrollTop = $dest.position().top;

    $('html,body').animate( {scrollTop}, 'slow');
  });
})
